module.exports = __webpack_public_path__ + "icon-youtube.png?8a580b69b5751f06d9692381c001f460";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-youtube.png
// module id = 246
// module chunks = 0